import axios from 'axios';
import store from '@/store/Store';

const API_URL = import.meta.env.VITE_API_URL;

export const fetchAsiakkaatByKeyword = async (keyword) => {
  if (keyword.trim().length < 4) {
    return [];
  }

  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/asiakas/haku?q=' + keyword, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
